import React, { useEffect, useState } from "react";
import useAxios from "../../utils/useAxios";
import Pagination from "../common/pagination";

const Announcement = () => {
  const [loading, setLoading] = useState(false);
  const [announcements, setAnnouncements] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const axiosAPI = useAxios();

  async function fetchAnnouncements() {
    try {
      setLoading(true);
      const response = await axiosAPI.get(
        `/api/announcement/get-announcement?page=${page}`
      );

      setAnnouncements(response?.data?.data);
      setTotalPages(response?.data?.totalPages);
    } catch (error) {
      console.error("Error fetching announcements:", error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchAnnouncements();
  }, [page]);

  const formatDate = (date) => {
    if (!date) return "";
    return new Date(date).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  // 🔥 DELETE FUNCTION
  const handleDelete = async (id) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this email?"
    );
    if (!isConfirmed) return;

    try {
      await axiosAPI.delete(
        `/api/announcement/delete-announcement/${id}`
      );

      window.notifyMessage(
        "Success",
        "Email deleted successfully",
        "success"
      );

      fetchAnnouncements(); // refresh list
    } catch (error) {
      console.error("Delete error:", error);
      window.notifyMessage(
        "Error",
        "Failed to delete email",
        "danger"
      );
    }
  };

  return (
    <div className="container">
      <div className="page-inner">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">
                  Announcement Emails ({announcements?.length})
                </h4>
              </div>

              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Email</th>
                        <th>Date</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="3" className="text-center">
                            Loading...
                          </td>
                        </tr>
                      ) : announcements?.length === 0 ? (
                        <tr>
                          <td colSpan="3" className="text-center">
                            No Emails Found.
                          </td>
                        </tr>
                      ) : (
                        announcements.map((item) => (
                          <tr key={item.id}>
                            <td>{item.email}</td>
                            <td>{formatDate(item.created_at)}</td>
                            <td>
                               <button
                                className="btn btn-icon btn-round btn-danger btn-sm me-2"
                                onClick={() => handleDelete(item.id)}
                              >
                                <i className="fas fa-trash"></i>
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <Pagination
              totalPages={totalPages}
              setPage={setPage}
              page={page}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Announcement;
